import { ITEM_RENDER_MODE } from '../constants';
const getEmptyItemSizeMap = () => ({
    [ITEM_RENDER_MODE.ShortLabel]: 0,
    [ITEM_RENDER_MODE.Collapsed]: 0,
    [ITEM_RENDER_MODE.Ellipsis]: 0,
    [ITEM_RENDER_MODE.Full]: 0,
});
const getElementWidth = (element) => element.getBoundingClientRect().width;
export function buildSizeMap(container) {
    if (!container) {
        return;
    }
    const children = container.children;
    const [separator, collapse, ...itemElements] = Array.from(children);
    return {
        separator: getElementWidth(separator),
        collapse: getElementWidth(collapse),
        items: itemElements.reduce((result, element) => {
            const id = element.getAttribute('data-id');
            const renderMode = element.getAttribute('data-render-mode');
            result[id] = result[id] || getEmptyItemSizeMap();
            result[id][renderMode] = getElementWidth(element);
            return result;
        }, {}),
    };
}
